import { generatePath } from 'react-router-dom';
import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { addParamsToUrl } from 'utils/query';

import { apiQuery } from '../../query';

import {
  Feature,
  RoleWithFeatures,
  RoleWithFeaturesRequest,
  UpdateRoleFeaturesRequest,
  UpdateRolesFeaturesRequest,
} from './types';

const tagTypes = ['features'];

export const featuresApi = createApi({
  tagTypes,
  baseQuery: apiQuery,
  reducerPath: 'featuresApi',
  endpoints: (build) => ({
    featuresByRole: build.query<RoleWithFeatures[], string>({
      providesTags: tagTypes,
      query: (id) => ({
        method: 'get',
        url: generatePath(URL.GET_FEATURES_BY_ROLES, { id }),
      }),
    }),

    rolesByFeature: build.query<RoleWithFeatures[], string>({
      providesTags: tagTypes,
      query: (name) => ({
        method: 'get',
        url: addParamsToUrl(URL.GET_ROLES_BY_FEATURE, { name }),
      }),
    }),

    list: build.query<RoleWithFeatures[], RoleWithFeaturesRequest>({
      providesTags: tagTypes,
      query: ({ ...params }) => ({
        method: 'get',
        url: addParamsToUrl(URL.GET_FEATURES, params),
      }),
    }),

    updateRolesFeatures: build.mutation<Feature[], UpdateRolesFeaturesRequest>({
      invalidatesTags: tagTypes,
      query: ({ ...data }) => ({
        data,
        method: 'patch',
        url: URL.UPDATE_ROLES_FEATURES,
      }),
    }),

    updateRoleFeatures: build.mutation<Feature[], UpdateRoleFeaturesRequest>({
      invalidatesTags: tagTypes,
      query: ({ id, ...data }) => ({
        data,
        method: 'patch',
        url: generatePath(URL.UPDATE_ROLE_FEATURES, { id: String(id) }),
      }),
    }),
  }),
});

export const {
  useListQuery,
  useFeaturesByRoleQuery,
  useRolesByFeatureQuery,
  useUpdateRoleFeaturesMutation,
  useUpdateRolesFeaturesMutation,
} = featuresApi;
